import ReactMarkdown from 'react-markdown';
import styled from 'styled-components';
import theme from '../../theme';

// -0.5 interlineado tipografía
// 36% de negro transparencia
// bold DESCUENTO

const Markdown = styled(ReactMarkdown)`
  &.background-sh {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p {
      color: inherit;
    }

    h1,
    h2,
    h3,
    h4 {
      text-shadow: ${({ shadow }) =>
        shadow ? '1px 1px 8px rgba(0, 0, 0, 0.5)' : 'inherit'};
    }

    ${theme.breakpoints.down('sm')} {
      h1 {
        margin-top: calc(25vh);
        font-size: 2rem;
        line-height: auto;
      }

      h2 {
        font-size: 1.8rem;
        line-height: auto;
      }

      p {
        font-size: 0.8rem;
        line-height: auto;
        font-weight: 700;
      }
    }
  }

  &.background {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p {
      color: inherit;
    }

    ${theme.breakpoints.down('sm')} {
      h1 {
        margin-top: calc(25vh);
        font-size: 2rem;
        line-height: auto;
      }

      h2 {
        font-size: 1.8rem;
        line-height: auto;
      }

      p {
        font-size: 0.8rem;
        line-height: auto;
        font-weight: 700;
      }
    }
  }

  h1 {
    color: black;
    font-family: 'Poppins', sans-serif;
    font-size: 3em;
    margin-top: 2rem;
  }

  h2 {
    font-family: 'Poppins', sans-serif;
    margin-top: -10px;
    color: black;
    font-size: 2.2em;

    &.gray {
      color: white;
    }
  }

  h3 {
    color: black;
    font-family: 'Poppins', sans-serif;
    font-size: 1.8em;
    margin-top: 1rem;
  }

  &.gallery {
    margin-bottom: 0;

    h2 {
      font-family: 'Poppins', sans-serif;
      margin-top: -10px;
      text-align: center;
      color: black;
      font-size: 3em;
      font-weight: 300;

      strong {
        font-weight: 600;
      }
    }
  }

  &.gray {
    color: ${(color) => color};
    font-family: inherit;
  }

  p {
    font-family: 'Poppins', sans-serif;
  }
`;

export default Markdown;
